import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import toast from 'react-hot-toast';
import { Badge, Box, Button, Flex, Grid, Image, Spinner, Text, useColorMode } from "theme-ui";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import * as Yup from "yup";
import { DeleteStageApiResponse, DeleteStageResponseData, RootState, SelectActionMeta, StageItemData, StageTaskItem, usersProps } from "../../../@types";
import { editStageById, getProjectById, getStageByProjectId, getStageCountsByDate, getTaskByProjectId } from "../../store/actions/project.action";
import { getAllUserWithoutPagination } from "../../store/actions/user.action";
import { Inputform } from "../forms-component/InputForm";
import EditStageView from "../pages/StagesView/EditStageView";
import { customStyles } from "../pages/createProject/StepTwo/CustomSelectStyles";
import { deleteStageByIdApi, deleteTaskByIdApi } from "../../store/api";
import { checkDeletionPermission } from "../../utils/GenerateQueryString";
import AddStage from "./AddStage/Stepperform";
interface props {
    projectId: string
}


const StepTwoOnly: React.FC<props> = ({ projectId }) => {

    const userData = useSelector((state: RootState) => state.project);
    const { userData: userState } = useSelector((state: RootState) => state.user);
    const { auther } = useSelector((state: RootState) => state.auth);
    const { stagebyproject, taskbyproject } = useSelector((state: any) => state.project);
    const { dataForTable } = useSelector((state: RootState) => state.masterData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const allStages = userData.createprojectMasterData?.allStages?.data || [];
    const allTask = userData.createprojectMasterData?.allTask?.data || [];
    const projectManagers = userData?.createprojectMasterData?.allProjectManagers || dataForTable?.data?.allProjectManagers || [];

    const projectWorkers = userData.createprojectMasterData?.allTaskWorkers || [];
    const salesReps = (userState?.data || []).filter((user: usersProps) =>
        user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES')
    );
    const salesRepOptions = salesReps.map((rep: usersProps) => ({
        value: rep?._id || '',
        label: `${rep?.FirstName || ''} ${rep?.LastName || ''}`.trim()
    }));
    const [isOpen, setIsOpen] = useState(false);
    const [stageError, setStageError] = useState<string | null>(null);
    const allStagesOptions = allStages?.map((stage) => ({
        value: stage?._id,
        label: stage?.name,
        color: stage?.color,
        backgroundColor: "#445adc",
        task: [],
        dueDate: '',
        promise: '',
        manager: '',
        worker: ''
    }));
    const [colorMode] = useColorMode();
    const [localStageData, setLocalStageData] = useState<any[]>([]);
    useEffect(() => {
        dispatch(getStageByProjectId(projectId))
        dispatch(getTaskByProjectId(projectId))
        dispatch(getStageCountsByDate())
        dispatch(getAllUserWithoutPagination())
    }, [dispatch, projectId])

    const allTaskOptions = allTask?.map((task) => ({
        value: task?._id,
        label: task?.name,
        color: colorMode === 'dark' && task?.color === '#000000' ? 'white' : task?.color,
        department: []
    }));

    const promise = [
        { label: "Customer", value: "Customer" },
        { label: "Personal", value: "Personal" },
        { label: "Hot Promise", value: "hotPromise" },
    ];
    const projectManagerOptions = projectManagers.map((manager: any) => ({
        value: manager?._id,
        label: `${manager?.FirstName} ${manager?.LastName}`
    })) || [];
    const projectWorkerOptions = projectWorkers?.map((worker: any) => ({
        value: worker?._id,
        label: `${worker?.FirstName} ${worker?.LastName}`
    })) || [];

    const validationSchema = Yup.object({
        stagesData: Yup.array()
            .min(1, "Select at least one stage")
            .of(
                Yup.object().shape({
                    task: Yup.array().min(1, "Select at least one task"),
                    dueDate: Yup.string().required("Due Date is required"),
                    promise: Yup.string().required("Promise is required"),
                    worker: Yup.string().required("Worker is required"),
                    manager: Yup.string().required("Manager is required"),
                })
            ),
    });

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema,
        initialValues: {

        },
        onSubmit: async (values, actions) => {

        },
    });
    const handleNextClick = () => {
        handleSubmit();
    };
    const handleStageChange = (id: string, checked: boolean) => {
        dispatch(editStageById({ toDisplay: checked }, id, "toDisplay", (success: boolean) => {
            if (success) {
                setLocalStageData((prevData) =>
                    prevData.map((stage) =>
                        stage?._id === id ? { ...stage, toDisplay: checked } : stage
                    )
                );
            }
        }));
    };
    useEffect(() => {
        if (stagebyproject) {
            setLocalStageData(stagebyproject);
        }
    }, [stagebyproject]);
    const { handleSubmit, setFieldValue, handleChange, handleBlur, touched, values, errors } = formik;
    const handleEditTask = (taskId: any) => {
        setIsOpen(true);
        navigate(`/edit-stages/${taskId}`);
    };

    const label = colorMode === 'light' ? "#0a0a0a" : "#fff";
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";

    const stageSelectStyles = {
        ...customStyles,
        control: (base: any) => ({
            ...base,
            backgroundColor: modalHeader,
            border: colorMode === 'light' ? '1px solid #cccccc' : '',
            borderColor: colorMode === 'light' ? '#cccccc' : '#3d4a6b',
            boxShadow: 'none',
            ':hover': {
                borderColor: colorMode === 'light' ? '#999999' : '#52648e',
            },
            borderRadius: '10px',
            padding: '6px 8px',
            alignItems: 'center',
            gap: '8px',
            alignSelf: 'stretch',
        }),
    };

    interface DeleteModalState {
        isOpen: boolean;
        type: 'stage' | 'task' | null;
        stageData: any;
        taskId?: string;
        itemTitle?: string;
        confirmationMessage?: string;
        isInitialConfirm?: boolean;
    }

    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    const [deleteModalState, setDeleteModalState] = useState<DeleteModalState>({
        isOpen: false,
        type: null,
        stageData: null,
        taskId: undefined,
        itemTitle: '',
        isInitialConfirm: true
    });

    const closeDeleteModal = () => {
        if (isDeleting) return;
        setDeleteModalState({
            isOpen: false,
            type: null,
            stageData: null,
            taskId: undefined,
            itemTitle: '',
            isInitialConfirm: true
        });
    };

    const buildConfirmationMsg = (resData: DeleteStageResponseData | DeleteStageApiResponse, defaultTitle: string, itemType: string) => {
        const dataKeys = resData?.dataKeys || resData?.data?.dataKeys;
        const msg = resData?.data?.message || resData?.message;

        if (dataKeys && Array.isArray(dataKeys) && dataKeys.length > 0) {
            const keysStr = dataKeys.join(', ');
            return `This ${itemType} has already ${keysStr}. Are you sure you want to delete it?`;
        }
        return msg || `Are you sure you want to delete ${defaultTitle} ${itemType}?`;
    };

    const confirmDeleteAction = () => {
        if (isDeleting) return;
        setIsDeleting(true);
        if (deleteModalState.type === 'stage' && deleteModalState.stageData?._id) {
            const stageId = deleteModalState.stageData._id;
            deleteStageByIdApi(stageId, true).then(() => {
                setIsDeleting(false);
                setLocalStageData((prevData) => prevData.filter((stage) => stage._id !== stageId));
                dispatch(getStageByProjectId(projectId));
                if (projectId) {
                    dispatch(getProjectById(projectId));
                }
                closeDeleteModal();
            }).catch(() => {
                setIsDeleting(false);
                closeDeleteModal();
            });
        } else if (deleteModalState.type === 'task' && deleteModalState.taskId && deleteModalState.stageData) {
            const removedTaskId = deleteModalState.taskId;
            const stage = deleteModalState.stageData;
            deleteTaskByIdApi(removedTaskId, true).then(() => {
                setIsDeleting(false);
                setLocalStageData((prevData) =>
                    prevData.map((stg) => {
                        if (stg._id === stage._id) {
                            return {
                                ...stg,
                                tasksNameList: (stg.tasksNameList || []).filter(
                                    (t: StageTaskItem) => ((t.taskDataId ? t.taskDataId.toString() : t._id?.toString()) || '') !== removedTaskId.toString()
                                )
                            };
                        }
                        return stg;
                    })
                );
                dispatch(getStageByProjectId(projectId));
                dispatch(getTaskByProjectId(projectId));
                closeDeleteModal();
            }).catch(() => {
                setIsDeleting(false);
                closeDeleteModal();
            });
        }
    };

    const handleDeleteStage = (stageToDelete: StageItemData, actionMeta: SelectActionMeta) => {
        if (actionMeta?.action === 'remove-value' || actionMeta?.action === 'pop-value' || actionMeta?.action === 'clear') {
            if (stageToDelete?._id) {
                const userRoles = auther?.Role || [];
                const checkResult = checkDeletionPermission(stageToDelete, userRoles, 'stage');

                if (!checkResult.allowed) {
                    toast.error(checkResult.message);
                    return;
                }

                setDeleteModalState({
                    isOpen: true,
                    type: 'stage',
                    stageData: stageToDelete,
                    itemTitle: stageToDelete?.name || 'stage',
                    confirmationMessage: checkResult.message,
                    isInitialConfirm: true
                });
            }
        }
    };

    const handleTaskChange = (stage: StageItemData, actionMeta: SelectActionMeta) => {
        if (actionMeta?.action === 'remove-value' || actionMeta?.action === 'pop-value') {
            const removedTaskId = actionMeta?.removedValue?.value;
            const taskName = actionMeta?.removedValue?.label || 'task';
            if (removedTaskId) {
                if ((stage?.tasksNameList?.length || 0) <= 1) {
                    const userRoles = auther?.Role || [];
                    const rolesList = Array.isArray(userRoles)
                        ? userRoles.map((r: { RoleName?: string } | string) => (typeof r === 'string' ? r : r?.RoleName || '')?.trim()?.toLowerCase())
                        : [];
                    const isSuperAdmin = rolesList.some((r: string) => r === 'super admin');
                    const isProjectManager = rolesList.some((r: string) => r === 'project manager');

                    if (!isSuperAdmin && !isProjectManager) {
                        toast.error("To delete this task, please contact to Super Admin.");
                        return;
                    }

                    toast("This task is the only remaining task in the stage, so it cannot be deleted individually. To remove it, please delete the entire stage.", { icon: '⚠️' });
                    return;
                }

                const taskItem = (stage?.tasksNameList || []).find(
                    (t: any) => ((t.taskDataId ? t.taskDataId.toString() : t._id?.toString()) || '') === removedTaskId.toString()
                );
                const fullTaskData = (taskbyproject || []).find(
                    (t: any) => (
                        t._id?.toString() === removedTaskId.toString() ||
                        t.taskId?._id?.toString() === removedTaskId.toString() ||
                        t.taskId?.toString() === removedTaskId.toString() ||
                        t.taskDataId?.toString() === removedTaskId.toString()
                    )
                );
                const taskToInspect = {
                    ...(taskItem || {}),
                    ...(fullTaskData || {}),
                    name: fullTaskData?.name || taskItem?.name || taskName,
                    highlighters: (fullTaskData?.highlighters && fullTaskData.highlighters.length > 0) ? fullTaskData.highlighters : (taskItem?.highlighters || []),
                    actions: (fullTaskData?.actions && fullTaskData.actions.length > 0) ? fullTaskData.actions : (taskItem?.actions || []),
                    taskEstimateList: fullTaskData?.taskEstimateList || taskItem?.taskEstimateList || [],
                    timeSpend: fullTaskData?.timeSpend || fullTaskData?.timeSpent || taskItem?.timeSpend || 0,
                };
                const userRoles = auther?.Role || [];
                const checkResult = checkDeletionPermission(taskToInspect, userRoles, 'task');

                if (!checkResult.allowed) {
                    toast.error(checkResult.message);
                    return;
                }

                setDeleteModalState({
                    isOpen: true,
                    type: 'task',
                    stageData: stage,
                    taskId: removedTaskId,
                    itemTitle: taskName,
                    confirmationMessage: checkResult.message,
                    isInitialConfirm: true
                });
            }
        }
    };

    return (
        <>
            <Box className="container-fluid" style={{ backgroundColor: modalHeader }}>
                <Box className="container-fluid d-flex" style={{ justifyContent: 'space-between' }}>
                    <Text as={'h4'} mt={3} mb={2}>
                        Stages
                    </Text>
                    <AddStage />
                </Box>

                <form onSubmit={handleSubmit}>
                    {localStageData?.map((selectedStage: any, stageIndex: number) => {
                        console.log('selectedStage', selectedStage);
                        const worker = projectWorkerOptions.find(option => option?.label)
                        const manager = projectManagerOptions.find(option => option?.label)

                        return (
                            <>
                                <Select
                                    isMulti
                                    classNamePrefix="an-simple-select"
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: '#F7EFE5',
                                        },
                                    })}
                                    options={[]}
                                    isSearchable={false}
                                    openMenuOnClick={false}
                                    isClearable={false}
                                    components={{ DropdownIndicator: () => null, ClearIndicator: () => null, IndicatorSeparator: () => null }}
                                    value={(() => {
                                        const matched = allStagesOptions.find(
                                            (option: { label: string; value: string }) =>
                                                option.label === selectedStage?.name ||
                                                option.value === (selectedStage?.stageId?._id || selectedStage?.stageId)
                                        );
                                        if (matched) {
                                            return {
                                                ...matched,
                                                label: selectedStage?.temporaryName || selectedStage?.name || matched.label,
                                                color: selectedStage?.color || matched.color,
                                            };
                                        }
                                        return selectedStage?.name || selectedStage?.temporaryName
                                            ? {
                                                value: selectedStage?._id || '',
                                                label: selectedStage?.temporaryName || selectedStage?.name,
                                                color: selectedStage?.color || '#000',
                                            }
                                            : undefined;
                                    })()}
                                    aria-labelledby="Select"
                                    onChange={(_, actionMeta) => handleDeleteStage(selectedStage, actionMeta)}
                                    styles={stageSelectStyles}
                                    isDisabled={false}
                                />
                                {/* parent boxes */}
                                <Box key={selectedStage?._id} sx={{
                                    boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.06);',
                                    borderRadius: '12px', p: 2, marginTop: 2
                                }}>

                                    <Box key={selectedStage?._id} sx={{ boxShadow: 'initial', p: 2, borderLeft: `4px solid ${selectedStage.color}`, }}>
                                        <Flex sx={{ alignItems: 'center', marginBottom: 2 }}>
                                            <Box sx={{ height: '100%', width: '4px', backgroundColor: selectedStage.color, marginRight: '8px' }} />
                                            <Box>
                                                <Flex
                                                    as={'h3'}
                                                    sx={{
                                                        color: selectedStage.color,
                                                        marginBottom: 0,
                                                        cursor: 'pointer',
                                                        gap: "10px",
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        width: '100%'
                                                    }}
                                                >
                                                    <div className="justify-content-between">
                                                        <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleEditTask(selectedStage?._id)}>
                                                            {selectedStage.temporaryName ? selectedStage.temporaryName : selectedStage.name}
                                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                                                                {selectedStage?.highlighters?.map((badge: any) => (
                                                                    <Badge
                                                                        key={badge?._id}
                                                                        color={badge?.color}
                                                                        sx={{
                                                                            backgroundColor: 'transparent',
                                                                            borderRadius: "8px",
                                                                            gap: '3px',
                                                                            padding: '4px 8px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            border: `1px solid ${badge?.color}`,
                                                                        }}
                                                                    >
                                                                        {badge?.icon && <Image
                                                                            title={badge.name}
                                                                            src={badge?.icon}
                                                                            alt={badge?.name}
                                                                            width={14}
                                                                            height={14}
                                                                        />}
                                                                        <Text sx={{ color: `${badge?.color}` }}>{badge?.name}</Text>
                                                                    </Badge>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Checkbox aligned to the right */}
                                                    <Box sx={{ marginLeft: 'auto' }}>
                                                        <span
                                                            style={{ display: 'inline-block', cursor: !selectedStage?.dueDate && !selectedStage?.clientDueDate && !selectedStage?.toDisplay ? 'not-allowed' : 'pointer' }}
                                                            onClick={() => {
                                                                if (!selectedStage?.dueDate && !selectedStage?.clientDueDate && !selectedStage?.toDisplay) {
                                                                    setStageError(selectedStage?._id);
                                                                } else {
                                                                    setStageError(null);
                                                                }
                                                            }}
                                                        >
                                                            <Inputform
                                                                label={""}
                                                                Placeholder={""}
                                                                type='checkbox'
                                                                Name={"toDisplay"}
                                                                Title_sx={{ color: "grey3" }}
                                                                values={selectedStage?.toDisplay}
                                                                disabled={!selectedStage?.dueDate && !selectedStage?.clientDueDate && !selectedStage?.toDisplay}
                                                                OnChange={(e: any) => handleStageChange(selectedStage?._id, e.target.checked)}
                                                            />
                                                        </span>
                                                        {stageError === selectedStage?._id && (
                                                            <span style={{ color: 'red', fontSize: '12px', display: 'block', marginTop: '4px' }}>
                                                                Please select due date and client due date.
                                                            </span>
                                                        )}
                                                    </Box>
                                                </Flex>
                                                <Text>
                                                    {selectedStage.status}
                                                </Text>
                                            </Box>



                                        </Flex>
                                        <Select
                                            isMulti
                                            classNamePrefix="an-simple-select"
                                            theme={(theme) => ({
                                                ...theme,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: '#F7EFE5',
                                                },
                                            })}
                                            options={[]}
                                            isSearchable={false}
                                            openMenuOnClick={false}
                                            isClearable={false}
                                            components={{ DropdownIndicator: () => null, ClearIndicator: () => null, IndicatorSeparator: () => null }}
                                            value={selectedStage?.tasksNameList?.map((task: any) => ({
                                                value: task?.taskDataId || task?._id,
                                                label: task?.name || "",
                                                color: task?.color || "#000",
                                            })) || []}
                                            aria-labelledby="Select"
                                            onChange={(_, actionMeta) => handleTaskChange(selectedStage, actionMeta)}
                                            styles={stageSelectStyles}
                                            isDisabled={false}
                                        />
                                        <Grid sx={{ gap: '1rem', marginTop: 3 }} columns={[1, 2, 2, 3, 4, 4]}>
                                            <Box>
                                                <Inputform
                                                    inputClassName="custom-datepicker-input"
                                                    wrapperClassName="date-input-wrapper"
                                                    sx={{ color: label, dayCounts: userData?.stageCounts || {} }}
                                                    type="date"
                                                    label="Due Date"
                                                    onBlur={handleBlur}
                                                    Name={`stagesData[${stageIndex}].dueDate`}
                                                    OnChange={handleChange}
                                                    values={selectedStage?.dueDate?.split('T')[0] || ''}
                                                    Placeholder=""
                                                    disabled
                                                />
                                            </Box>
                                            <Box>
                                                <Inputform
                                                    inputClassName="custom-datepicker-input"
                                                    wrapperClassName="date-input-wrapper"
                                                    sx={{ color: label }}
                                                    type="date"
                                                    label="Client Due Date"
                                                    onBlur={handleBlur}
                                                    Name={`stagesData[${stageIndex}].clientDueDate`}
                                                    OnChange={handleChange}
                                                    values={selectedStage?.clientDueDate?.split('T')[0] || ''}
                                                    Placeholder=""
                                                    disabled
                                                />
                                            </Box>
                                            <Box>
                                                <Text variant="SelectLabel" sx={{ color: label }}>Promise:</Text>
                                                <Select
                                                    classNamePrefix="an-simple-select"
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#F7EFE5',
                                                        },
                                                    })}
                                                    options={promise}
                                                    onBlur={handleBlur}
                                                    value={promise.find(option => option.label === selectedStage.promise)}
                                                    onChange={(selectedOption: any) => setFieldValue(`stagesData[${stageIndex}].promise`, selectedOption?.value || '')}
                                                    isDisabled={true}
                                                />
                                            </Box>
                                            <Box>
                                                <Text variant="SelectLabel" sx={{ color: label }}>Sales Representative:</Text>
                                                <Select
                                                    classNamePrefix="an-simple-select"
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#F7EFE5',
                                                        },
                                                    })}
                                                    placeholder={
                                                        (() => {
                                                            const rawRep = selectedStage?.projectId?.salesRepresentative || selectedStage?.salesRepresentative;
                                                            const repId = typeof rawRep === 'object' ? rawRep?._id : rawRep;
                                                            const isExist = salesReps.some((r: usersProps) => r._id === repId);
                                                            if (isExist && rawRep) {
                                                                const repObj = salesReps.find((r: usersProps) => r._id === repId);
                                                                if (repObj) {
                                                                    return `${repObj.FirstName || ''} ${repObj.LastName || ''}`.trim();
                                                                }
                                                                if (typeof rawRep === 'object') {
                                                                    return `${rawRep.FirstName || ''} ${rawRep.LastName || ''}`.trim();
                                                                }
                                                            }
                                                            return 'Select Sales Representative';
                                                        })()
                                                    }

                                                    value={salesRepOptions.find(option => option.value === (
                                                        selectedStage.projectId?.salesRepresentative?._id ||
                                                        selectedStage.projectId?.salesRepresentative ||
                                                        selectedStage.salesRepresentative?._id ||
                                                        selectedStage.salesRepresentative ||
                                                        selectedStage.worker?._id ||
                                                        selectedStage.worker
                                                    ))}
                                                    options={[{ value: '', label: 'Select Sales Representative' }, ...salesRepOptions]}
                                                    onBlur={handleBlur}
                                                    onChange={(selectedOption) =>
                                                        formik.setFieldValue(`stagesData[${stageIndex}].salesRepresentative`, selectedOption?.value || '')}
                                                    isDisabled={true}
                                                />
                                            </Box>
                                            <Box>
                                                <Text variant="SelectLabel" sx={{ color: label }}>Project Manager:</Text>
                                                <Select
                                                    classNamePrefix="an-simple-select"
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#F7EFE5',
                                                        },
                                                    })}
                                                    placeholder={
                                                        (() => {
                                                            const rawManager = selectedStage?.manager || selectedStage?.projectId?.projectManager;
                                                            const pmId = typeof rawManager === 'object' ? rawManager?._id : rawManager;
                                                            const pmList = projectManagers.length > 0 ? projectManagers : (dataForTable?.data?.allProjectManagers || []);
                                                            const isPmActive = pmList.some((x: { _id: string }) => x._id === pmId);
                                                            if (isPmActive && rawManager) {
                                                                if (typeof rawManager === 'object') {
                                                                    return `${rawManager.FirstName || ''} ${rawManager.LastName || ''}`.trim() || 'Select Project Manager';
                                                                }
                                                                const foundPm = pmList.find((x: { _id: string }) => x._id === pmId);
                                                                if (foundPm) {
                                                                    return `${foundPm.FirstName || ''} ${foundPm.LastName || ''}`.trim() || 'Select Project Manager';
                                                                }
                                                            }
                                                            return 'Select Project Manager';
                                                        })()
                                                    }
                                                    onBlur={handleBlur}
                                                    value={
                                                        (() => {
                                                            const rawManager = selectedStage?.manager || selectedStage?.projectId?.projectManager;
                                                            const pmId = typeof rawManager === 'object' ? rawManager?._id : rawManager;
                                                            const pmList = projectManagers.length > 0 ? projectManagers : (dataForTable?.data?.allProjectManagers || []);
                                                            const isPmActive = pmList.some((x: { _id: string }) => x._id === pmId);
                                                            return isPmActive ? projectManagerOptions.find((option: { value: string }) => option.value === pmId) || null : null;
                                                        })()
                                                    }
                                                    onChange={(selectedOption) =>
                                                        formik.setFieldValue(`stagesData[${stageIndex}].manager`, selectedOption?.value || '')}
                                                    options={[{ value: '', label: 'Select Project Manager' }, ...projectManagerOptions]}
                                                    isDisabled={true}
                                                />
                                            </Box>

                                        </Grid>
                                    </Box>
                                </Box>
                            </>
                        )
                    })}
                </form>
            </Box>
            {isOpen && (
                <EditStageView

                />
            )}
            <Modal isOpen={deleteModalState.isOpen} toggle={closeDeleteModal} size="sm" centered>
                <ModalHeader toggle={closeDeleteModal} style={{ backgroundColor: modalHeader, color: label }}>
                    Confirm Deletion
                </ModalHeader>
                <ModalBody style={{ backgroundColor: modalHeader, color: label }}>
                    {deleteModalState.confirmationMessage || `Are you sure you want to delete ${deleteModalState.itemTitle} ${deleteModalState.type}?`}
                </ModalBody>
                <ModalFooter style={{ backgroundColor: modalHeader }}>
                    <Button variant="CancelButton" sx={{ mr: 2, cursor: isDeleting ? 'not-allowed' : 'pointer' }} onClick={closeDeleteModal} disabled={isDeleting}>No</Button>
                    <Button type="button" variant="SaveButton" sx={{ cursor: isDeleting ? 'not-allowed' : 'pointer' }} onClick={confirmDeleteAction} disabled={isDeleting}>
                        {isDeleting ? <Spinner size={16} sx={{ color: '#fff' }} /> : 'Yes'}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default StepTwoOnly;
